import React, {useState, useEffect, useContext} from 'react'
import {EditedContext} from '../../../../partials/Context'

function Contact({activBox}) {
    const [cities, setCities] = useState([]);
    const edited = useContext(EditedContext)
    const {edited_item, setEditedItem, lawyer_data, changeBtn, input_value, setInputValue} = edited || '';
    const {company_name, address_street, address_post_code, address_city, address_street_second, address_post_code_second, address_city_second, open_to_free_consultations, open_to_customers, phone, phone2, user, website, clients_type} = lawyer_data || '';
    const {name: city_name} = address_city || ''
    const {name: city_name_second} = address_city_second || ''
    const {email} = user || ''
    const {address_city: input_city, user: input_user, address_city_second: input_city_second} = input_value || ''
    const {name: input_city_name} = input_city || ''
    const {name: input_city_second_name} = input_city_second || ''
    const {email: input_email} = input_user || ''

    let cities_list = []
    let clients_types_list = []

    const clients_types = {
        0: 'Klienci biznesowi',
        1: 'Klienci indywidualni',
        2: 'Obie grupy'
    }

    useEffect(() => {
        fetch('/api/cities/').then(res => {
            res.json().then(
                data => {
                    setCities(data)
                }
            )
        })
    },[])

    if (cities) {
        cities.forEach(city => {
            const {name, id} = city || ''
            cities_list.push(
                <option
                    key={id} value={name}>{name}
                </option>
            )
        })
        cities_list.unshift(
            <option></option>
        )
    }

    Object.keys(clients_types).forEach(type => {
        clients_types_list.push(
            <option value={type} key={type}>{clients_types[type]}</option>
        )
    })
    clients_types_list.unshift(
            <option></option>
    )

  return (
    <div className="personal-data-section" id="contact-section">
        <h3 className="title">Dane kontaktowe</h3>
        <div className="content">
            <div className="company-name">
                {edited_item === 'company_name' ? 
                    <input type="text" className="form-input" value={input_value.company_name} onChange={(e)=>setInputValue({company_name: e.target.value})}/>
                    :
                    <span id="company-name">{company_name ? company_name : 'nazwa kancelarii'}</span>
                }
                {changeBtn('company_name')}
            </div>
            <div className="address-first">
                {edited_item === 'address-first' ? 
                <>
                <span id="address-first">Ulica, numer budynku i lokalu&nbsp;</span>
                <input type="text" className="form-input" value={input_value.address_street} 
                onChange={
                    (e)=> {
                        setInputValue({...input_value, address_street: e.target.value})
                    }
                }
                />
                <span id="city_name">&nbsp;Najbliższa miejscowość&nbsp;</span>
                <input list="cities" value={input_city_name}  onChange={
                    (e)=> {
                        setInputValue({...input_value, address_city: {name: e.target.value}})
                    }
                }/>
                <datalist id="cities" >
                    {cities_list}
                </datalist>
                <br/>
                <span id="address_post_code">Kod pocztowy&nbsp;</span>
                <input type="text" className="form-input" value={input_value.address_post_code} 
                onChange={
                    (e)=> {
                        setInputValue({...input_value, address_post_code: e.target.value})
                    }
                }
                />
                </>
                :
                <span id="address-first">{address_street || address_post_code || city_name ? `${address_street}, ${address_post_code} ${city_name}` : 'adres' }</span>
                }
                {changeBtn('address-first')}
            </div>
            <div className="address-second">
                {edited_item === 'address-second' ? 
                    <>
                <span id="address-second">Ulica, numer budynku i lokalu&nbsp;</span>
                <input type="text" className="form-input" value={input_value.address_street_second} 
                onChange={
                    (e)=> {
                        setInputValue({...input_value, address_street_second: e.target.value})
                    }
                }
                />
                <span id="city_name_second">&nbsp;Najbliższa miejscowość&nbsp;</span>
                <input list="cities" value={input_city_second_name}  onChange={
                    (e)=> {
                        setInputValue({...input_value, address_city_second: {name: e.target.value}})
                    }
                }/>
                <datalist id="cities" >
                    {cities_list}
                </datalist>
                <br/>
                <span id="address_post_code_second">Kod pocztowy&nbsp;</span>
                <input type="text" className="form-input" value={input_value.address_post_code_second} 
                onChange={
                    (e)=> {
                        setInputValue({...input_value, address_post_code_second: e.target.value})
                    }
                }
                />
                </>
                :
                <span id="address-second">
                    {address_street_second || address_post_code_second || city_name_second ? `${address_street_second}, ${address_post_code_second} 
                    ${city_name_second}` : 'drugi adres'}
                    
                </span>
                }
                
                {changeBtn('address-second')}
            </div>
            <div className="free-consultation">
                <span id="free-consultation">
                    Bezpłatna konsultacja:&ensp;
                    <input type="checkbox" name="free-consultation" checked={input_value.open_to_free_consultations === undefined ? open_to_free_consultations : input_value.open_to_free_consultations} onClick={()=>{
                        setEditedItem('free-consultation')
                        if (input_value.open_to_free_consultations === undefined) {
                            setInputValue({open_to_free_consultations: !open_to_free_consultations})
                        } else {
                            setInputValue({open_to_free_consultations: !input_value.open_to_free_consultations})
                        }

                    }}
                    />
                    {changeBtn('free-consultation')}
                </span>
            </div>
            <div className="new-clients">
                <span id="new-clients">
                    Przyjmuje nowych klientów:&ensp;
                    <input type="checkbox" name="new-clients" checked={input_value.open_to_customers === undefined ? open_to_customers : input_value.open_to_customers}  onClick={()=>{
                        setEditedItem('new-clients')
                        if (input_value.open_to_customers === undefined) {
                            setInputValue({open_to_customers: !open_to_customers})
                        } else {
                            setInputValue({open_to_customers: !input_value.open_to_customers})
                        }

                    }}/>
                    {changeBtn('new-clients')}
                </span>
            </div>
            <div className="clients">
                {edited_item === 'clients_type' ? 
                    <select name="title" id="title" onChange={(e) => setInputValue({clients_type: e.target.value})}>
                        {clients_types_list}
                    </select>
                    :
                    <span id="clients">Obsługiwani klienci:&emsp; {clients_types[clients_type]}
                </span>
                }
                {changeBtn('clients_type')}
            </div>
            <div className="phone-number">
                {edited_item === 'phone' ?
                    <span id="phone-number">tel.: 
                        <input type="text" className="form-input" value={input_value.phone} onChange={(e)=>setInputValue({phone: e.target.value})}/>
                    </span>
                    :
                    <span id="phone-number">tel.: &emsp;{phone ? phone : '-'}</span>
                }
                {changeBtn('phone')}
            </div>
            <div className="cell-phone-number">
                {edited_item === 'phone2' ?
                    <span id="cell-phone-number">tel.: 
                        <input type="text" className="form-input" value={input_value.phone2} onChange={(e)=>setInputValue({phone2: e.target.value})}/>
                    </span>
                    :
                    <span id="cell-phone-number">kom.: &emsp;{phone2 ? phone2 : '-'}</span>
                }   
                {changeBtn('phone2')}
            </div>
            <div className="email">
                {edited_item === 'email' ?
                    <span id="email">email: 
                        <input type="text" className="form-input" value={input_email} onChange={(e)=>setInputValue({user: {email: e.target.value}})}/>
                    </span>
                    :
                    <span id="email">email: &emsp; {email}</span>
                }
                {changeBtn('email')}
            </div>
            <div className="website">
                {edited_item === 'website' ? 
                    <span id="website">www: 
                        <input type="url" className="form-input" value={input_value.website} onChange={(e)=>setInputValue({website: e.target.value})}/>
                    </span>
                    :
                    <span id="website">www:  &emsp;{website ? website : '-'}</span>
                }
                {changeBtn('website')}
            </div>

        </div>
        {activBox === false ?
        <div className="activbox">
            <img src='/media/img/profile/activbox.png' alt="activbox"/>
            <span>Tu może być ekran Twojego ActivBox</span>
        </div>
        : null}
        {activBox === false ?
        <div className="activbox-services">
            <a href="/activbox/o-usludze-activbox/">Co to jest System Usług?</a>
            <a href="/activbox/utworz/" className="btn btn-info">Utwórz System Usług</a>
        </div> : null}
    </div>
  )
}

export default Contact